import {
    DEFAULT_MAX_ADDED_FILTER_VALUE,
    DEFAULT_MAX_LAST_UPDATED_FILTER_VALUE,
    DEFAULT_MIN_ADDED_FILTER_VALUE,
    DEFAULT_MIN_LAST_UPDATED_FILTER_VALUE
} from "@components/widgets/PluginsList";
import {
    DEFAULT_MAX_ACTIVE_INSTALLS_FILTER_VALUE,
    DEFAULT_MAX_DOWNLOADS_FILTER_VALUE,
    DEFAULT_MAX_RATING_FILTER_VALUE,
    DEFAULT_MAX_TOTAL_RATINGS_FILTER_VALUE
} from "@components/widgets/PluginsTable";
import {IPluginData} from "@hooks/plugins/IPluginsDataResponse";

export interface IPluginsQuery {
    pluginid?: string
    search?: string
    name?: string
    description?: string
    languages?: string[]
    tags?: string[]
    sortColumn?: string
    sortDescending?: boolean
    page?: number
    per_page?: number
    min_rating?: number
    max_rating?: number
    min_active_installs?: number
    max_active_installs?: number
    min_downloads?: number
    max_downloads?: number
    min_total_ratings?: number
    max_total_ratings?: number
    min_last_updated?: string
    max_last_updated?: string
    min_added?: string
    max_added?: string
    min_age_days?: number
    max_age_days?: number
}

export interface IPluginsQueryResult {
    plugins: IPluginData[]
    current_page: number
    total_plugins: number
    plugins_per_page: number
    total_pages: number
}

export function pluginsQueryToAPIRequestParams(pluginsQuery: IPluginsQuery, params: URLSearchParams = new URLSearchParams()): URLSearchParams {

    if (pluginsQuery.pluginid) {
        params.append('pluginid', pluginsQuery.pluginid);
    }

    if (pluginsQuery.search) {
        params.append('search', pluginsQuery.search);
    }

    if (pluginsQuery.name) {
        params.append('name', pluginsQuery.name);
    }

    if (pluginsQuery.description) {
        params.append('description', pluginsQuery.description);
    }

    if (pluginsQuery.languages?.length) {
        pluginsQuery.languages.forEach((language: string) => {
            params.append('languages', language);
        });
    }

    if (pluginsQuery.tags?.length) {
        pluginsQuery.tags.forEach((tag: string) => {
            params.append('tags', tag);
        });
    }

    if (pluginsQuery.min_rating && pluginsQuery.min_rating > 0 && pluginsQuery.min_rating <= DEFAULT_MAX_RATING_FILTER_VALUE) {
        params.append('min_rating', pluginsQuery.min_rating.toString());
    }

    if (pluginsQuery.max_rating && pluginsQuery.max_rating > 0 && pluginsQuery.max_rating < DEFAULT_MAX_RATING_FILTER_VALUE) {
        params.append('max_rating', pluginsQuery.max_rating.toString());
    }

    if (pluginsQuery.min_active_installs && pluginsQuery.min_active_installs > 0) {
        params.append('min_active_installs', pluginsQuery.min_active_installs.toString());
    }

    if (pluginsQuery.max_active_installs && pluginsQuery.max_active_installs > 0 && pluginsQuery.max_active_installs < DEFAULT_MAX_ACTIVE_INSTALLS_FILTER_VALUE) {
        params.append('max_active_installs', pluginsQuery.max_active_installs.toString());
    }

    if (pluginsQuery.min_downloads && pluginsQuery.min_downloads > 0) {
        params.append('min_downloads', pluginsQuery.min_downloads.toString());
    }

    if (pluginsQuery.max_downloads && pluginsQuery.max_downloads > 0 && pluginsQuery.max_downloads < DEFAULT_MAX_DOWNLOADS_FILTER_VALUE) {
        params.append('max_downloads', pluginsQuery.max_downloads.toString());
    }

    if (pluginsQuery.min_total_ratings && pluginsQuery.min_total_ratings > 0) {
        params.append('min_total_ratings', pluginsQuery.min_total_ratings.toString());
    }

    if (pluginsQuery.max_total_ratings && pluginsQuery.max_total_ratings > 0 && pluginsQuery.max_total_ratings < DEFAULT_MAX_TOTAL_RATINGS_FILTER_VALUE) {
        params.append('max_total_ratings', pluginsQuery.max_total_ratings.toString());
    }

    if (pluginsQuery.min_last_updated && pluginsQuery.min_last_updated !== DEFAULT_MIN_LAST_UPDATED_FILTER_VALUE) {
        params.append('min_last_updated', pluginsQuery.min_last_updated);
    }

    if (pluginsQuery.max_last_updated && pluginsQuery.max_last_updated !== DEFAULT_MAX_LAST_UPDATED_FILTER_VALUE) {
        params.append('max_last_updated', pluginsQuery.max_last_updated);
    }

    if (pluginsQuery.min_added && pluginsQuery.min_added !== DEFAULT_MIN_ADDED_FILTER_VALUE) {
        params.append('min_added', pluginsQuery.min_added);
    }

    if (pluginsQuery.max_added && pluginsQuery.max_added !== DEFAULT_MAX_ADDED_FILTER_VALUE) {
        params.append('max_added', pluginsQuery.max_added);
    }

    if (pluginsQuery.min_age_days && pluginsQuery.min_age_days > 0) {
        params.append('min_age_days', pluginsQuery.min_age_days.toString());
    }

    if (pluginsQuery.max_age_days && pluginsQuery.max_age_days > 0) {
        params.append('max_age_days', pluginsQuery.max_age_days.toString());
    }

    if (pluginsQuery.sortColumn) {
        params.append('orderby', pluginsQuery.sortColumn);
        params.append('order', pluginsQuery.sortDescending ? 'desc' : 'asc');
    }

    if (pluginsQuery.page) {
        params.append('page', pluginsQuery.page.toString());
    }

    if (pluginsQuery.per_page) {
        params.append('per_page', pluginsQuery.per_page.toString());
    }

    return params;
}

// export const usePluginsData = async function (pluginsQuery?: IPluginsQuery, returnRawData: boolean = false): Promise<IProcessedPluginsData | IPluginsQueryResult | undefined> {
//
//     if (!pluginsQuery){
//         return undefined;
//     }
//     return;
//
//     RequestsControllerService.getInstance().clearControllers('plugins');
//     const controller = new AbortController();
//     RequestsControllerService.getInstance().addController('plugins', controller);
//
//     let url = process.env.NEXT_PUBLIC_PLUGINS_DB_API_ENDPOINT + '/plugins';
//     const params = pluginsQueryToAPIRequestParams(pluginsQuery, new URLSearchParams());
//
//
//     const method = 'GET';
//
//     const headers = {
//         'Content-Type': 'application/json',
//     }
//     return fetch(url + '?' + params.toString(), {
//         method: method,
//         headers: headers,
//         signal: controller?.signal,
//     }).then(async (response: Response): Promise<IProcessedPluginsData | IPluginsQueryResult | undefined> => {
//         if (response.ok) {
//             const data = await response.json();
//             if (returnRawData) {
//                 return data;
//             }
//             return Plugins.processApiResponse(data);
//         }
//     })
// }
//
// export const usePluginsLanguages = async (pluginsQuery: IPluginsQuery | undefined): Promise<LanguageOption[]> => {
//     if (!pluginsQuery){
//         return [];
//     }
//     return;
//
//     RequestsControllerService.getInstance().clearControllers('languages');
//     const controller = new AbortController();
//     RequestsControllerService.getInstance().addController('languages', controller);
//
//     let url = process.env.NEXT_PUBLIC_PLUGINS_DB_API_ENDPOINT + '/plugins/languages';
//     const params = pluginsQueryToAPIRequestParams(pluginsQuery, new URLSearchParams());
//     const method = 'GET';
//
//     const headers = {
//         'Content-Type': 'application/json',
//     }
//
//     const json = (await (await fetch(url + '?' + params.toString(), {
//         method: method,
//         headers: headers,
//         signal: controller?.signal,
//     })).json())
//     return json.data.map((languageAPIData: any): LanguageOption => {
//         return new LanguageOption(languageAPIData.slug, languageAPIData.english_name + ' (' + languageAPIData.plugins_count + ')');
//     });
// }

// export const usePluginsTags = async (pluginsQuery: IPluginsQuery | undefined): Promise<TagOption[]> => {
//     if (!pluginsQuery){
//         return [];
//     }
//     return;
//
//     RequestsControllerService.getInstance().clearControllers('tags');
//     const controller = new AbortController();
//     RequestsControllerService.getInstance().addController('tags', controller);
//
//     let url = process.env.NEXT_PUBLIC_PLUGINS_DB_API_ENDPOINT + '/plugins/tags';
//     const params = pluginsQueryToAPIRequestParams(pluginsQuery, new URLSearchParams());
//     const method = 'GET';
//
//     const headers = {
//         'Content-Type': 'application/json',
//     }
//
//     const json = (await (await fetch(url + '?' + params.toString(), {
//         method: method,
//         headers: headers,
//         signal: controller?.signal,
//     })).json())
//     return json.data.map((tagAPIData: any): TagOption => {
//         return new TagOption(tagAPIData.slug, tagAPIData.label + ' (' + tagAPIData.plugins_count + ')');
//     });
// }


export const pluginPropertyKeyToLabel = (key: string) => key.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
